
import { InactiveCycles } from '../../InactiveCycles/InactiveCycles';

export const Inactive = () => {
  return (
    <div className="c-cycles-by-status flex flex-auto flex-col gap-y-2">
      <InactiveCycles />
    </div>
  );
};
